import { formatEquation, formatSide, type Equation } from '../../shared/algebra.ts';
import type { MathTarget } from './replyAlignment.ts';
import { inkLine } from './inkGlyphs.ts';

/** Exact printed token geometry. Implicit coefficients have no glyph to point at. */
export function writtenTarget(equation:Equation,target:MathTarget|undefined){
  if(!target)return undefined;
  const text=formatEquation(equation),left=formatSide(equation.left.x,equation.left.constant);
  let start:number,end:number;
  if(target.role==='equals'){start=left.length+1;end=start+1;}
  else {
    if(target.side==='relation')return undefined;
    const side=equation[target.side],printed=formatSide(side.x,side.constant),offset=target.side==='left'?0:left.length+3;
    const x=printed.indexOf('x');
    if(target.role==='variable'){if(x<0)return undefined;start=offset+x;end=start+1;}
    else if(target.role==='coefficient'){
      if(x<=0||printed.slice(0,x)==='-')return undefined;
      start=offset;end=offset+x;
    }else {
      if(x>=0&&side.constant==='0')return undefined;
      start=offset+(x<0?0:side.constant.startsWith('-')?x+2:printed.lastIndexOf(' ')+1);end=offset+printed.length;
    }
  }
  const prefix=text.slice(0,start),value=text.slice(start,end);
  return {text:value,x:prefix?inkLine(prefix).width:0,width:inkLine(value).width};
}

export function noteSentence(text:string,position=0){
  const sentences=[...text.matchAll(/\S[\s\S]*?(?:[.!?](?=\s|$)|$)/g)];
  const sentence=sentences.find(s=>position>=s.index!&&position<s.index!+s[0].length)??sentences[0];
  return sentence?{start:sentence.index!,end:sentence.index!+sentence[0].length}:{start:0,end:text.length};
}
